import React from "react";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Card } from "react-bootstrap";

import PortalService from '../../../services/portal.service';
import StateContext from '../../../context/State';
import AddCustomFieldModal from "./AddCustomFieldModal";

import type { CustomFieldsResponse } from "../../../types";

const CustomFields = () => {
    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [customFields, setCustomFields] = useState<CustomFieldsResponse>([]);

    // eslint-disable-next-line
    useEffect(() => {
        // adding delay to account for potential empty array
        const timeout = setTimeout(() => {
            getCustomFieldsData();
        }, 2000)

        return () => clearTimeout(timeout)
    }, []);

    const getCustomFieldsData = async () => {
        const response: CustomFieldsResponse = await portalService.getClientPortalCustomFields(state.portalId);
        setCustomFields(response)
    }

    return (
        <Card >
            <Card.Header>
                <Card.Title>Custom Fields</Card.Title>
            </Card.Header>

            <Card.Body>
                <Row >
                    {customFields.map((field, index) => {
                        const value = field.Value ?? undefined;
                        return (
                            <Col className="col-4 mb-3" key={field.Name + '-custom-field-' + index}>
                                <React.Fragment>
                                    <Form.Label>{field.Name}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        readOnly={true}
                                        value={value}
                                        placeholder={!value && 'Not Submitted'}
                                    />
                                </React.Fragment>
                            </Col>
                        );
                    })}
                </Row>
                    <br />
                <Row>
                    <Col>
                        <Button onClick={() => setShowModal(true)}>
                            {customFields.length === 0 ? 'Add' : 'Edit'} Custom Fields
                        </Button>
                        <AddCustomFieldModal
                            getCustomFieldsData={getCustomFieldsData}
                            showModal={showModal}
                            onHideModal={() => {
                                getCustomFieldsData()
                                setShowModal(false)
                            }}
                        />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

export default CustomFields;
